export default __webpack_public_path__ + "static/media/space-aura.49f4a8eb.svg";